<template>
    <div class="Foot">
        <section>
            <div>
                <h3 @click="handleNav('/')">首页</h3>
            </div>
            <div>
                <h3 @click="handleNav('/about')">关于傲天</h3>
                <p @click="handleAbout('jj')" class="click-p">企业简介</p>
                <p @click="handleAbout('wh')" class="click-p">企业文化</p>
                <p @click="handleAbout('zz')" class="click-p">企业资质</p>
                <p @click="handleAbout('lc')" class="click-p">企业历程</p>
            </div>
            <div>
                <h3 @click="handleNav('/news/0')">新闻动态</h3>
                <p @click="handleNews(20)" class="click-p">行业动态</p>
                <p @click="handleNews(10)" class="click-p">公司动态</p>
            </div>
            <div>
                <h3 @click="handleNav('/product')">产品系列</h3>
                <!-- <p @click="handleProduct('cxxt01')" class="click-p">智能采血系统01系列 </p>
                <p @click="handleProduct('cxxt02')" class="click-p">智能采血系统02系列 </p>
                <p @click="handleProduct('jkzx')" class="click-p">智能健康征询系统</p>
                <p @click="handleProduct('czpt')" class="click-p">智能移动操作平台 </p>
                <p @click="handleProduct('xybb')" class="click-p">血液标本后处理系统 </p>
                <p @click="handleProduct('lljk')" class="click-p">智能冷链监控系统 </p>
                <p @click="handleProduct('cxc')" class="click-p">智能采血秤 </p>
                <p @click="handleProduct('rhj')" class="click-p">智能热合机 </p>
                <p @click="handleProduct('xxw')" class="click-p">智慧献血屋方案 </p> -->
                <p @click="handleProductType('cplx1')" class="click-p">血站产品</p>
                <p @click="handleProductType('cplx2')" class="click-p">临床产品</p>
            </div>
            <div >
                <h3 @click="handleNav('/successful')">成功案例</h3>
            </div>
            <div>
                <h3 @click="handleNav('/contact')">联系我们</h3>
                <p class="contact-p"><span>邮箱：</span>service@sinoatma.com</p>
                <p class="contact-p"><span>电话：</span>+86 0755 2813 0111 </p>
                <p class="contact-p"><span>地址：</span>深圳市龙华区龙华街道清湖社区宝能科技园三期1栋A座一单元5层</p>
                <p class="contact-p">
                    <img  src="/imgs/erweima.png" alt="">
                </p>
            </div>
        </section>
        <footer>
            <span>
                ©2012-2021 深圳市傲天医疗智能系统有限公司 SHENZHEN SINOATMA MEDICAL-CARE INTELLIGENCE CO.,LTD.
            </span>
            <span>
                <a href="https://beian.miit.gov.cn" target="_blank">
                    备案号：粤ICP备16065996号-3
                </a>
            </span>
        </footer>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
    name: "Foot",
    components: {},
    data() {
        return {};
    },
    methods: {
        handleNav(e){
            if(e == this.$route.path){
                location.href=e
            }else{
                document.body.parentNode.style.overflowY ="auto"
                this.$router.push(e);
            }
            // location.href=e
        },
        handleAbout(e){
            location.href='/about?id='+e
        },
        handleNews(e){
            location.href='/news/'+e
        },
        handleProduct(e){
            location.href='/'+e+'?nav=Product'
        },
        handleProductType(e){
            location.href='/product?productType='+e
        },
    },
    created() {},
    mounted() {},
    beforeUnmount() {},
};
</script>
<style lang="less" scoped>
.Foot {
    width: 100vw;
    background: #E8E8E8;
    > section {
        width: 67rem;
        max-width: calc(100vw - 40px);
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 80px 0;
        >div{
            text-align: left;
            width: 11rem;
            >h3{
                color: #000;
                font-size: 1rem;
                font-weight: bold;
                cursor: pointer;
                transition: all 0.3s ease;
                &:hover{
                    text-decoration: underline;
                }
                :active{
                    text-decoration: underline;
                }
                -webkit-tap-highlight-color: rgba(0,0,0,0);/*CSS3去除手机浏览器按钮点击出现的高亮框*/
                -webkit-tap-highlight-color: transparent;
                -moz-tap-highlight-color: transparent;
            }
            >p{
                color:#666666;
                font-size: 0.9rem;
                width: auto;
                -webkit-tap-highlight-color: rgba(0,0,0,0);/*CSS3去除手机浏览器按钮点击出现的高亮框*/
                -webkit-tap-highlight-color: transparent;
                -moz-tap-highlight-color: transparent;
            }
            .click-p{
                cursor: pointer;
                transition: all 0.3s ease;
                &:hover{
                    text-decoration: underline;
                    color:#000;
                }
                &:active{
                    text-decoration: underline;
                    color:#000;
                }
            }
            .contact-p{
                display: flex;
                width: 14rem;
                >span{
                    white-space: nowrap;
                }
            }
        }
    }
    >footer{
        text-align: center;
        background: #E8E8E8;
        min-height: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #666666;
        font-size: 0.77rem;
        >span{
            margin: 0 2rem;
        }
        a{
            color: #666666;
            text-decoration: none;
        }
    }
}
</style>
